import React, { Component } from 'react';
import { Table, Button, Input, Modal, message, InputNumber, Popconfirm } from 'antd';
import API from '../../../api/api';
import UEditor from "../../components/ueditor/ueditor";
import './prizePreview.less';
var uploader = require('../../../thirdTool/alioss/upload.js');
class PrizePreview extends Component {
    constructor(props) {
        super(props)
    }
    state = {
        columns: [
            {
                title: '奖项名称',
                dataIndex: 'prizeName',
                key: 'prizeName',
            },
            {
                title: '实物奖个数',
                dataIndex: 'realPrizeNum',
                key: 'realPrizeNum',
            },
            {
                title: '内定个数（实物）',
                dataIndex: 'defaultRealPrizeNum',
                key: 'defaultRealPrizeNum',
            },
            {
                title: '现金奖个数',
                dataIndex: 'cashPrizeNum',
                key: 'cashPrizeNum',
            },
            {
                title: '内定个数（现金）',
                dataIndex: 'defaultCashPrizeNum',
                key: 'defaultCashPrizeNum',
            },
            {
                title: '金额',
                dataIndex: 'singleMoney',
                key: 'singleMoney',
            },
            {
                title: '总金额',
                dataIndex: 'totalMoney',
                key: 'totalMoney',
            },
        ],
        data:[]
    }
    componentDidMount() {
    
    }
    componentWillReceiveProps(nextProps) {
        
    }   
    handleAddModalOk = e => {//添加或编辑对话框点击确定后
        this.props.onModalSuccess&&this.props.onModalSuccess();
    };

    handleAddModalCancel = e => {//添加或编辑对话框点击取消后
        this.props.onModalClose&&this.props.onModalClose();
    };
    render() {
        const {
            columns,
            data
        } = this.state;
        return (
            <Modal
                destroyOnClose={true}
                title={'奖项分布'}
                visible={this.props.show}
                onOk={this.handleAddModalOk}
                onCancel={this.handleAddModalCancel}
                width={600}
                footer={[
                    <Button key="submit" type="primary" onClick={this.handleAddModalOk}>
                        确认发布
                        </Button>,
                    <Button key="back" onClick={this.handleAddModalCancel}>
                        取消
                        </Button>,
                ]}
            >
                <Table columns={columns}
                    dataSource={this.props.data}
                    rowKey={row => row.id}
                    pagination={false}
                />
            </Modal>
        )
    }
}
export default PrizePreview;
